<template>
  <div>
    <Return_product_add/>
  </div>
</template>

<script>
import Return_product_add from "@/components/adminArin/pos_system/warehouse/return_product/Return_product_add";
export default {
  name: "Returnproductadd",
  components: {
    Return_product_add
  }
}
</script>

<style scoped>

</style>
